
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { ProductModel } from 'models/generated/Entities.GormCrm.Product';
import { ProductVariantModel } from 'models/generated/Entities.GormCrm.ProductVariant';
import { VariantListModel } from 'models/generated/Entities.GormCrm.VariantList';
import { ProductTagFilterModel } from 'models/generated/Entities.GormCrm.ProductTagFilter';
import { TagModel } from 'models/generated/Models.TagModel';


const _gormCrm_ProductControllerHelper = new Map<string, Object>();
_gormCrm_ProductControllerHelper.set('GetProducts', ProductModel);
_gormCrm_ProductControllerHelper.set('GetProductById', ProductModel);
_gormCrm_ProductControllerHelper.set('GetVariant', ProductVariantModel);
_gormCrm_ProductControllerHelper.set('GetVariantList', VariantListModel);
_gormCrm_ProductControllerHelper.set('GetVariantLists', VariantListModel);
_gormCrm_ProductControllerHelper.set('GetProductFilters', ProductTagFilterModel);
_gormCrm_ProductControllerHelper.set('GetProductTags', TagModel);
_gormCrm_ProductControllerHelper.set('CreateProduct', ProductModel);
_gormCrm_ProductControllerHelper.set('CreateVariantList', VariantListModel);
_gormCrm_ProductControllerHelper.set('UpdateVariantList', VariantListModel);


export const gormCrm_ProductControllerHelper = _gormCrm_ProductControllerHelper;

